<ui-tab-group class="hidden md:block">
  <ui-tab>
    <ui-skeleton class="rounded-full h-5 w-5 me-1.5" />
    <ui-skeleton class="rounded-full h-3 w-[74px]" />
  </ui-tab>
  <ui-tab>
    <ui-skeleton class="rounded-full h-5 w-5 me-1.5" />
    <ui-skeleton class="rounded-full h-3 w-[74px]" />
  </ui-tab>
  <ui-tab>
    <ui-skeleton class="rounded-full h-5 w-5 me-1.5" />
    <ui-skeleton class="rounded-full h-3 w-[74px]" />
  </ui-tab>
</ui-tab-group>
